import { useLayoutEffect } from 'react';

// Elementos que aparecen con una animación suave al entrar en pantalla.
const SELECTOR = [
  'section > .title',
  '.services-intro',
  '.about-me-target',
  '.target-stat',
  '.target-service',
  '.target-skills',
  '.extra-skills-group',
  '.target-project',
  '.target-experience',
  '.education-group',
  '.target-education',
  '.education-languages',
  '.contact-content > .text',
  '.contact-content > .social-networks',
  '.contact-form',
].join(',');

// Añade la clase "reveal" a cada elemento y "is-visible" cuando entra en pantalla.
// Las animaciones viven en Motion.css. Si el usuario prefiere menos movimiento,
// no se hace nada y el contenido se ve de inmediato.
export function useScrollReveal(){
  useLayoutEffect(() => {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    const seen = new WeakSet();

    const register = () => {
      document.querySelectorAll(SELECTOR).forEach((el) => {
        if (seen.has(el)) return;
        seen.add(el);

        // Retraso escalonado entre hermanos (máximo 4 escalones, 90 ms cada uno)
        const siblings = Array.from(el.parentElement.children).filter((child) => child.matches(SELECTOR));
        el.style.setProperty('--reveal-delay', `${(siblings.indexOf(el) % 4) * 90}ms`);

        el.classList.add('reveal');
        observer.observe(el);
      });
    };

    register();

    // Elementos que aparecen después (por ejemplo, al pulsar "Ver más proyectos")
    const mutations = new MutationObserver(register);
    mutations.observe(document.getElementById('root'), { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutations.disconnect();
    };
  }, []);
}
